import { c as _c } from "react/compiler-runtime";
import type { CreateWaveDatesConfig, CreateWaveOutcomeConfig } from "@/types/waves.types";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveOutcomesCICRank from "./CreateWaveOutcomesCICRank";
import CreateWaveOutcomesCICApprove from "./CreateWaveOutcomesCICApprove";
import type { JSX } from "react";
export default function CreateWaveOutcomesCIC(t0) {
  const $ = _c(12);
  const {
    waveType,
    dates,
    onOutcome,
    onCancel
  } = t0;
  let t1;
  if ($[0] !== dates || $[1] !== onCancel || $[2] !== onOutcome || $[3] !== waveType) {
    t1 = <CreateWaveOutcomesCICApprove onOutcome={onOutcome} onCancel={onCancel} dates={dates} waveType={waveType} />;
    $[0] = dates;
    $[1] = onCancel;
    $[2] = onOutcome;
    $[3] = waveType;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onCancel || $[6] !== onOutcome) {
    t2 = <CreateWaveOutcomesCICRank onOutcome={onOutcome} onCancel={onCancel} />;
    $[5] = onCancel;
    $[6] = onOutcome;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2) {
    t4 = {
      [ApiWaveType.Approve]: t1,
      [ApiWaveType.Rank]: t2,
      [ApiWaveType.Chat]: t3
    };
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const components = t4;
  return components[waveType];
}